import { headerBgRepeat } from './HeaderBgStore.js';

export const updateHeaderBgRepeat = (value) => headerBgRepeat.update(oldValue => value);
